import React from 'react'
import AboutContent from '../component/Home/about'
import CourseGridd from '../component/Home/course'
import WhyChoseContent from '../component/Home/whyChose'
// import EventContent from '../component/Home/event'
import TeamContent from '../component/Home/team'
import GalleryContet from '../component/Home/PhotoGallery'
import CounterSection from '../component/Home/counter'
import SwiperSlider from '../component/Home/swiper'
import ParallaxCotent from '../component/Home/parallax'
import BoxContainer from '../component/Home/box'
import Model from '../component/Home/Model'

const HomeContent = () => {
  return (
    <>
      <SwiperSlider />
      <BoxContainer />
      <AboutContent />
      <CounterSection />
      <ParallaxCotent />
      <CourseGridd />
      <WhyChoseContent />
      {/* <EventContent /> */}
      <TeamContent />
      <GalleryContet />
      <Model />
    </>
  )
}

export default HomeContent
